import { EyeIcon, SparklesIcon, ShieldCheckIcon, ClipboardListIcon } from 'lucide-react';

export const slides = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/sypFUW8zuJ6JwTw6VV9hK2/01-clase-reformer.webp',
    alt: 'Página de la clase de Reformer "Primer contacto con el carro", con bloques de ejercicios y tiempos',
    title: 'Una clase de Reformer organizada por bloques',
    caption: 'Secuencia de 45 minutos con ejercicios, dosis y referencias a sus fichas.',
    note: 'Tomo 2, página 46. Es la primera página de una clase de dos páginas: la clase continúa con montajes y decisiones en la página siguiente del PDF.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/bHAzUbXK24HxonfYYwgkom/02-ejercicio-matwork.webp',
    alt: 'Ficha del ejercicio Bird Dog, con objetivo, ejecución, errores frecuentes y progresión',
    title: 'Cada ejercicio, explicado en una página',
    caption: 'Posición, ejecución, errores frecuentes y opciones para adaptar la dificultad.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/mbssCqCmaVe3DpABU4c3N2/03-ejercicio-aro.webp',
    alt: 'Ficha de presión lateral del aro entre muslos, con error frecuente y corrección',
    title: 'Observa el error y encuentra cómo corregirlo',
    caption: 'Una ficha con aro, alternativa sencilla y propuesta de progresión.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/mqpXSc9ZLYr2PcsG5k2Ceq/04-clase-pared.webp',
    alt: 'Página de la clase "Control global sin suelo", con bloques de ejercicios en pared y silla',
    title: 'Una clase de pie con pared y silla',
    caption: 'Orden, tiempos y dosis para una sesión sin trabajo tumbado.',
    note: 'Tomo 5, página 56. Es la primera página de una clase de dos páginas: la clase continúa con montajes y decisiones en la página siguiente del PDF.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/eEMc865yYpKRHBA3Qs3nkE/07-ejercicio-reformer.webp',
    alt: 'Ficha del ejercicio Talones paralelos en Reformer, con montaje, dosis y errores frecuentes',
    title: 'Reformer: cada ejercicio con una guía para enseñarlo',
    caption: 'Consulta el montaje, la ejecución y la dosis de trabajo, con errores frecuentes, correcciones y opciones para simplificar o progresar.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/oKXMwhGShcZrkjXWctXyWu/08-puente-pared.webp',
    alt: 'Ficha de Puente bajo con pies en pared, con montaje, dosis y opciones de adaptación',
    title: 'Pilates en pared: adapta el ejercicio a tu alumnado',
    caption: 'Una ficha visual con posición inicial, movimiento y regreso, acompañada de una alternativa más sencilla y un criterio para avanzar.'
  }
];

export const highlights = [
  {
    icon: EyeIcon,
    title: 'Claridad Instantánea',
    text: 'Imágenes de referencia para acompañar la explicación de cada ejercicio.'
  },
  {
    icon: SparklesIcon,
    title: 'Cues de Élite',
    text: 'Las frases exactas que ayudan a tus alumnas a conectar con el movimiento.'
  },
  {
    icon: ShieldCheckIcon,
    title: 'Correcciones a la vista',
    text: 'Errores frecuentes en rojo y su corrección en verde, para actuar a tiempo.'
  },
  {
    icon: ClipboardListIcon,
    title: 'Estrategia Aplicada',
    text: 'Guías de indicación para grupos mixtos y planificadores semanales: un punto de partida concreto para seleccionar, adaptar y registrar tu clase.'
  }
];
